// Progress shown while an interaction is being built, instead of the streamed code
import { withStyles } from '@material-ui/core'
import React from 'react'
import styles from './styles'
import { BUILD_READY_LABEL, BUILD_STAGES } from './utils'

const MCP_ARTICLE_URL =
  'https://intercom.help/mini-course-generator/en/articles/15054631-mini-course-generator-mcp-connect-mcg-to-chatgpt-claude-cursor-and-other-ai-tools'

const getStageLabel = progress =>
  progress.done ? BUILD_READY_LABEL : BUILD_STAGES[progress.stageIndex]

const ProgressBar = ({ classes, percent, large = false }) => (
  <div className={`${classes.track} ${large ? classes.trackLarge : ''}`}>
    <div className={classes.fill} style={{ width: `${percent}%` }} />
  </div>
)

const BuildProgressBubbleBase = ({ classes, progress }) => (
  <div className={classes.bubble}>
    <div className={classes.bubbleHeader}>
      <span className={classes.bubbleTitle}>Building the interaction</span>
      <span className={classes.bubblePercent}>{progress.percent}%</span>
    </div>
    <ProgressBar classes={classes} percent={progress.percent} />
    <div className={classes.bubbleStage}>{getStageLabel(progress)}</div>
  </div>
)

const BuildProgressPanelBase = ({ classes, progress }) => {
  const stepNumber = Math.min(BUILD_STAGES.length, progress.stageIndex + 1)

  return (
    <div className={classes.panel}>
      <div className={classes.panelContent}>
        <div className={classes.summary}>
          <div className={classes.stepCount}>
            Step {stepNumber} of {BUILD_STAGES.length}
          </div>
          <div className={classes.summaryRow}>
            <div className={classes.stageTitle}>{getStageLabel(progress)}</div>
            <div className={classes.percentLarge}>{progress.percent}%</div>
          </div>
          <ProgressBar classes={classes} percent={progress.percent} large />
        </div>

        <ul className={classes.stageList}>
          {BUILD_STAGES.map((label, index) => {
            const isDone = index < progress.stageIndex
            const isActive = index === progress.stageIndex
            return (
              <li
                key={label}
                className={`${classes.stageItem} ${
                  isActive ? classes.stageItemActive : ''
                } ${!isDone && !isActive ? classes.stageItemPending : ''}`}
              >
                <span
                  className={`${classes.dot} ${isDone ? classes.dotDone : ''} ${
                    isActive ? classes.dotActive : ''
                  }`}
                >
                  {isDone ? '✓' : ''}
                </span>
                {label}
              </li>
            )
          })}
        </ul>

        <div className={classes.tip}>
          <span className={classes.tipBadge}>TIP</span>
          <div className={classes.tipText}>
            You can also create interactions directly from Claude or other AI
            tools with the Mini Course Generator MCP.{' '}
            <a href={MCP_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
              Learn how
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export const BuildProgressBubble = withStyles(styles)(BuildProgressBubbleBase)
export const BuildProgressPanel = withStyles(styles)(BuildProgressPanelBase)
